/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".login-bg[_ngcontent-%COMP%]{background-image:url(/assets/images/bg_login.jpg);background-position:center;background-repeat:no-repeat;background-size:cover;top:0;left:0;width:100%;height:100%;z-index:-2}.btn-primary[_ngcontent-%COMP%]{color:#fff;background-color:#0067b8;border-color:#0067b8}"];
export { styles as styles };
